// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"afa83f57","176":"5fa4ecf7","237":"afa83f57","331":"b608ce4a"}[chunkId] + ".chunk.css";
};